import { useEffect, useRef } from "react";
import { TimeoutRef } from "shared/helpers/helperModels";

export const useDebounce = <T extends (...args: any[]) => any>(
  cb: T,
  delay: number
) => {
  const timeoutId = useRef<TimeoutRef>(null);

  useEffect(() => {
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, []);

  return function (...args: Parameters<T>) {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => cb(...args), delay);
  };
};
